import { IDemandViewModel, ISolicitationViewModel } from 'viewModels';
import { v4 as uuid } from 'uuid';
import { HistoryType, labelHistoryType } from '../../types/enums';
import { Attachment } from '../Attachment';
import { LineDate } from '../LineDate';
import { Content } from './styles';
import { ReactComponent as NoteIcon } from '../../assets/icons/NoteIcon.svg';

interface HistoricSolicitationProps {
  service: ISolicitationViewModel | IDemandViewModel;
  isVisible: boolean;
}

export function HistoricService({ service, isVisible }: HistoricSolicitationProps) {
  return (
    <Content className={isVisible ? '' : 'displayNone'}>
      <h1>Histórico</h1>
      <div className="historic-scroll">
        {service.history?.map((history) => (
          <div className="historicItem" key={history.id ?? uuid()}>
            <LineDate date={history.createdAt} />
            <div className="historicItemContainer">
              {Object.keys(labelHistoryType)
                .filter((h) => Number(h) === Number(history.type))
                .map((status) => (
                  <h2 key={status}>{labelHistoryType[status as unknown as HistoryType]}</h2>
                ))}
              <div className="historicItemContent">
                {history.type === HistoryType.ATTACHMENT && <p>{history.text}</p>}
                <div className="containerAttachments">
                  {history.attachments?.map((attachment) => (
                    <div className="historicItemAttachment" key={attachment.id ?? uuid()}>
                      <Attachment
                        options={{
                          disableDelete: true,
                          disableDownload: false,
                          disableView: false,
                        }}
                        data={{
                          id: attachment.id,
                          name: attachment.extension
                            ? attachment.name + attachment.extension
                            : attachment.name,
                          file: attachment.file,
                          type: attachment.contentType,
                          uri: attachment.url,
                        }}
                      />
                    </div>
                  ))}
                </div>
                {history.type === HistoryType.NOTE && (
                  <div className="containerNote">
                    <NoteIcon />
                    <div className="contentNote">
                      <h2>{history.createdBy}</h2>
                      <p>
                        Anotado em{' '}
                        {new Date(history.createdAt).toLocaleString('pt-BR', {
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric',
                          hour: 'numeric',
                          minute: 'numeric',
                        })}
                      </p>
                      <p className="noteDescription">{history.text}</p>
                    </div>
                  </div>
                )}
                {history.type === HistoryType.NEW_DATELIMIT && (
                  <p>
                    {history.createdBy} alterou a data limite de{' '}
                    {new Date(history.prevSolicitationDateLimit as Date).toLocaleDateString(
                      'pt-BR',
                      {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                      },
                    )}{' '}
                    para{' '}
                    {new Date(history.newSolicitationDateLimit as Date).toLocaleDateString(
                      'pt-BR',
                      {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                      },
                    )}
                  </p>
                )}
                {history.type === HistoryType.UPDATE_SOLICITATION_VALUE && (
                  <p>
                    {history.createdBy} alterou o valor da solicitação de{' '}
                    {history.prevSolicitationValue !== undefined &&
                      new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(history.prevSolicitationValue)}{' '}
                    para{' '}
                    {history.newSolicitationValue !== undefined &&
                      new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(history.newSolicitationValue)}
                  </p>
                )}
                {history.type === HistoryType.UPDATE_SOLICITATION && (
                  <div className="updateDetails">
                    {history.text && (
                      <div className="changesList">
                        {history.text
                          .split('Alterações: ')[1]
                          ?.split('; ')
                          .map((change, index) => (
                            <div key={index} className="changeItem">
                              • {change}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                )}
                {history.type !== HistoryType.NOTE &&
                  history.type !== HistoryType.NEW_DATELIMIT &&
                  history.type !== HistoryType.ATTACHMENT &&
                  history.type !== HistoryType.UPDATE_SOLICITATION && <p>{history.text}</p>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Content>
  );
}
